import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTemplate, getUiOptions, } from '@rjsf/utils';
import { Text } from '@fluentui/react';
export default function FieldTemplate(props) {
    const { children, errors, help, displayLabel, description, rawDescription, hidden, uiSchema, registry } = props;
    const uiOptions = getUiOptions(uiSchema);
    const WrapIfAdditionalTemplate = getTemplate('WrapIfAdditionalTemplate', registry, uiOptions);
    if (hidden) {
        return _jsx("div", { style: { display: 'none' }, children: children });
    }
    return (_jsxs(WrapIfAdditionalTemplate, { ...props, children: [children, displayLabel && rawDescription && _jsx(Text, { children: description }), errors, help] }));
}
//# sourceMappingURL=FieldTemplate.js.map